export const DialogTestAttributes = {
    xButtonE2eId: 'dialog-x-button',
    confirmButtonE2eId: 'dialog-confirm-button',
    cancelButtonE2eId: 'dialog-cancel-button',
    titleE2eId: 'dialog-title',
    descriptionE2eId: 'dialog-description',
};
